import { Card, Checkbox, Form, Title } from 'components/common'

export interface ProductApprovalRequiredProps {
  isApprovalRequired?: boolean
  loading?: boolean
}

export interface ProductApprovalRequiredFromValues {
  isApprovalRequired: boolean
}

export const ProductApprovalRequired = ({
  isApprovalRequired,
  loading = false,
}: ProductApprovalRequiredProps): JSX.Element => (
  <Card shadow loading={loading}>
    <Title level={5}>承認の必要有無</Title>

    <Form.Item
      name="approvalRequired"
      initialValue={isApprovalRequired}
      valuePropName="checked"
      noStyle
    >
      <Checkbox>この施設を予約するには承認を必要とします。</Checkbox>
    </Form.Item>
  </Card>
)
